import React from "react";
import { motion } from "framer-motion";
import { 
    LightBulbIcon, 
    GlobeAltIcon,
} from "@heroicons/react/24/outline";

import EtVideoPanel2 from "@/components/media/EtVideoPanel2";


const EtEternityMission = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 04 Oct 2025 - Refined the message as well as added Video panel
  // Updated - 05 Oct 2025 - Replaced video panel with EtVideoPanel comp

  return (
    <section
      id="mission"
      className="relative py-20 bg-gray-900 text-white overflow-hidden"
    >
      {/* Background gradient animation */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-800 to-black animate-[pulse_12s_ease-in-out_infinite]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
        
        {/* Left content */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-orange-600 mb-6">
            {/* What Drives Us */}
            What Our Work Does for You
          </h2>
          {/* 25 Nov 2025 */}
          <p className="text-gray-300 mb-4 text-xl md:text-lg">
            At <span className="text-orange-400 font-semibold">Eternity Solutions</span>,  
            we help organizations rediscover their purpose and turn it into performance.  
            Growth begins with clarity, is carried by people, and is lifted by technology.
          </p>
          {/* <p className="text-gray-300 mb-4 text-xl md:text-lg">
            At <span className="text-orange-400 font-semibold">Eternity Solutions</span>, we exist to help 
            organizations rediscover their purpose and turn it into performance. 
            We believe in building{" "}
            <span className="font-semibold text-white">purpose-native enterprises</span> — 
            where clarity fuels conviction, people power progress, and technology 
            amplifies human potential.
          </p> */}

          {/* 25 Nov 2025 */}
          <ul className="space-y-4 text-gray-300">
            <li className="flex items-start gap-3">
              <LightBulbIcon className="h-6 w-6 text-orange-500 shrink-0" />
              <span>Clarity of purpose leads to confident action.</span>
            </li>
            <li className="flex items-start gap-3">
              <GlobeAltIcon className="h-6 w-6 text-orange-500 shrink-0" />
              <span>Connected teams and ecosystems amplify growth.</span>
            </li>
          </ul>
          {/* <ul className="space-y-4 text-gray-300">
            <li className="flex items-start gap-3">
                <LightBulbIcon className="h-6 w-6 text-orange-500 shrink-0" />
                <span>
                We believe clarity of purpose ignites confident action.
                </span>
            </li>
            <li className="flex items-start gap-3">
                <GlobeAltIcon className="h-6 w-6 text-orange-500 shrink-0" />
                <span>
                We believe connected ecosystems multiply growth and impact.
                </span>
            </li>
          </ul> */}



            <p className="text-gray-300 text-xl md:text-lg mt-4">
              {/* 25 Nov 2025 */}
              <span className="text-white font-bold">Why many playbooks stall :</span>  
                too many tools, scattered efforts, and leaders under pressure to use AI  
                without first shifting the behaviors that matter.  
                This video introduces <span className="text-orange-400 font-poppins">Thinking Growth, </span> 
                a way to pause, spot the gaps, and build growth that compounds over time.


        {/* <span className="text-white font-bold">Why many playbooks stall:</span> tool-first tactics, scattered initiatives, and overloaded leaders treating AI as a panacea—without the behavior shift first. The video introduces <span className="text-orange-400 font-poppins">Thinking Growth</span>—a practical way to spot the gaps and design a system that compounds growth over time. */}
        {/* <span className="text-white font-bold">Why many playbooks stall:</span> tool-first tactics, scattered initiatives, and overloaded leaders treating AI as a panacea—without the behavior shift first. The video introduces <span className="text-orange-400 font-poppins">Thinking Growth</span>— highlighting the need to pause, spot the gaps and then design a practical way that compounds growth over time. */}
            </p>
        </motion.div>       

        {/* Right image / visual */}
        <motion.div
            className="relative w-full rounded-xl overflow-hidden shadow-lg h-64 sm:h-80 md:h-[22rem] lg:h-[26rem]"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <EtVideoPanel2
                // videoId="7BfpH2zHaI0"
                videoId="btIzyH7RW_E"
                // videoId="ddfkioJ7xhU" // CxOs in a new org
                // videoId="H8kqCbXajHw" // Unlocking Team Performance
                className="relative w-full rounded-xl overflow-hidden shadow-lg h-64 sm:h-80 md:h-[22rem] lg:h-[26rem]"
            />
            </motion.div>
      </div>
    </section>
  );
};

export default EtEternityMission;